// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-gallery-container {
    max-height: 343px;
    overflow-y: scroll;
    padding-right: 16px;
}

.easycommerce-gallery-container::-webkit-scrollbar {
	width: 5px;
    border-radius: 9999px;
}

.easycommerce-gallery-container::-webkit-scrollbar-track {
	background: #F0EDFB;
    border-radius: 9999px;
}

.easycommerce-gallery-container::-webkit-scrollbar-thumb {
	background-color: #7F7F98; 
	border-radius: 9999px;
}

.easycommerce-gallery-container::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
}`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Products/components/Gallery/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;CACC,UAAU;IACP,qBAAqB;AACzB;;AAEA;CACC,mBAAmB;IAChB,qBAAqB;AACzB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,QAAQ;AACZ","sourcesContent":[".easycommerce-gallery-container {\n    max-height: 343px;\n    overflow-y: scroll;\n    padding-right: 16px;\n}\n\n.easycommerce-gallery-container::-webkit-scrollbar {\n\twidth: 5px;\n    border-radius: 9999px;\n}\n\n.easycommerce-gallery-container::-webkit-scrollbar-track {\n\tbackground: #F0EDFB;\n    border-radius: 9999px;\n}\n\n.easycommerce-gallery-container::-webkit-scrollbar-thumb {\n\tbackground-color: #7F7F98; \n\tborder-radius: 9999px;\n}\n\n.easycommerce-gallery-container::-webkit-scrollbar-button {\n    display: none;\n    height: 0;\n    width: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
